/* Necessary imports */
import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  LTAnchoredOverlay,
  LTCopyToClipboard,
  LTIconButton,
  LTInputBox
} from "@lambdatestincprivate/lt-components";

import { withRouter } from "../../../utility/withRouter";

import AccessKey from "../../../images/access-key-top-nav";
import styles from "./index.module.css";

const PopUpOptions = {
  ACCESS_KEY: "accessKey",
  HUB: "hub",
  USER: "user"
};

const ConditionalAccessKeyPopUp = ({
  children,
  renderOnlyInnerContent = false
}) => {
  if (renderOnlyInnerContent) {
    return <>{children}</>;
  }
  return (
    <LTAnchoredOverlay
      ariaLabel="Connection Details"
      customComponent={
        <LTIconButton
          aria-label="Connection Details"
          data-testid="new-dashboard-key-icon"
          icon={() => <AccessKey />}
          size={LTIconButton.Size.SMALL}
        />
      }
    >
      {children}
    </LTAnchoredOverlay>
  );
};

const AccessKeyPopUp = ({
  renderOnlyInnerContent = false,
  userInfo,
  accessKey = ""
}) => {
  let username = "N/A";
  if (
    userInfo &&
    !userInfo.loading &&
    userInfo.data &&
    userInfo.data.username
  ) {
    username = userInfo.data.username;
  }

  const hubUrl = `https://${username}:${accessKey}@${process.env.REACT_APP_HUB_URL}`;

  return (
    <ConditionalAccessKeyPopUp renderOnlyInnerContent={renderOnlyInnerContent}>
      <div className={styles.accessKeyContainer}>
        <div className={styles.accessKeyTitle}>Connection Details</div>
        <div className={styles.separator} />
        <div className={styles.accessKeySectionWrapper}>
          <div className={styles.accessKeySection}>
            <div className={styles.accessKeySectionTitle}>Hub</div>
            <div className={styles.accessKeyValueSection}>
              <LTInputBox
                ariaLabel="Hub"
                autoCompleteType="off"
                className={styles.ltTextInput}
                disabled={true}
                leadingIcon=""
                name="Hub"
                size={LTInputBox.Size.MEDIUM}
                value={hubUrl}
              />
              <LTCopyToClipboard
                buttonVariant={LTIconButton.IconButtonVariants.DEFAULT}
                buttonClassName={styles.ltIconButtonInput}
                copyAriaLabel="Copy Hub Url"
                copiedAriaLabel="Hub Url Copied"
                data-testid="hub-url-copy"
                textToCopy={hubUrl}
                useNavigator
              />
            </div>
          </div>
          <div className={styles.accessKeySection}>
            <div className={styles.accessKeySectionTitle}>Username</div>
            <div className={styles.accessKeyValueSection}>
              <LTInputBox
                ariaLabel="Username"
                autoCompleteType="off"
                className={styles.ltTextInput}
                disabled={true}
                leadingIcon=""
                name="Username"
                size={LTInputBox.Size.MEDIUM}
                value={username}
              />
              <LTCopyToClipboard
                buttonVariant={LTIconButton.IconButtonVariants.DEFAULT}
                buttonClassName={styles.ltIconButtonInput}
                copyAriaLabel="Copy Username"
                copiedAriaLabel="Username Copied"
                data-testid="access-username"
                textToCopy={username}
                useNavigator
              />
            </div>
          </div>
          <div className={styles.accessKeySection}>
            <div className={styles.accessKeySectionTitle}>Access Key</div>
            <div className={styles.accessKeyValueSection}>
              <LTInputBox
                ariaLabel="Access Key"
                autoCompleteType="off"
                className={styles.ltTextInput}
                disabled={true}
                leadingIcon=""
                name="Access Key"
                size={LTInputBox.Size.MEDIUM}
                value={"**********"}
              />
              <LTCopyToClipboard
                buttonVariant={LTIconButton.IconButtonVariants.DEFAULT}
                buttonClassName={styles.ltIconButtonInput}
                copyAriaLabel="Copy Access Key"
                copiedAriaLabel="Access Key Copied"
                data-testid="access-key-copy"
                textToCopy={accessKey}
                useNavigator
              />
            </div>
          </div>
        </div>
      </div>
    </ConditionalAccessKeyPopUp>
  );
};

const mapStateToProps = state => {
  return {
    accessKey: state.auth.accessKeyData?.token?.token,
    userInfo: state.userInfo.userInfo
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AccessKeyPopUp)
);
